import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useCapitalDecreaseModal } from '../context/CapitalDecreaseModalContext';
import CapitalDecreaseMovementsView from './CapitalDecreaseMovementsView';
import CapitalDecreaseScriptureView from './CapitalDecreaseScriptureView';

const CapitalDecreaseModalBody: FC = () => {
  const { data } = useCapitalDecreaseModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? (
          <CapitalDecreaseScriptureView />
        ) : (
          <CapitalDecreaseMovementsView />
        )}
      </div>
    </Modal.Body>
  );
};

export default CapitalDecreaseModalBody;
